import LazyPage from "./LazyPage";

export default LazyPage